"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8299],{

/***/ 84469:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ ExpressDealModal; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(69396);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var pcln_modal__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(97679);
/* harmony import */ var pcln_design_system__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(92591);
/* harmony import */ var _components_StyledHeading__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(29293);
/* harmony import */ var _hooks_useExpressDealModal__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(77185);
/* harmony import */ var _constants_analytics__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(66487);
/* harmony import */ var _constants_content__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(66410);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(33765);
/* harmony import */ var _SearchForm_utils__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(91753);
/* harmony import */ var _SearchForm_Form__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(93853);













/**
 * TODO: Add fallback in StyleHeading, please refer
 * commit history for fallback text
 */ function ExpressDealModal(param) {
    var isModalOpen = param.isModalOpen, _gaCategory = param.gaCategory, gaCategory = _gaCategory === void 0 ? _constants_analytics__WEBPACK_IMPORTED_MODULE_4__/* .ANALYTICS_CATEGORY_FLIGHTS */ .y1 : _gaCategory, _qsKey = param.qsKey, qsKey = _qsKey === void 0 ? "modal" : _qsKey, _qsValue = param.qsValue, qsValue = _qsValue === void 0 ? "express-deals" : _qsValue;
    var closeModal = (0,_hooks_useExpressDealModal__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(qsKey, qsValue).closeModal;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(pcln_modal__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
        isOpen: isModalOpen,
        onClose: closeModal,
        width: [
            1,
            750
        ],
        enableOverflow: true,
        timeout: 50,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(pcln_design_system__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
            p: [
                3,
                0
            ],
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(pcln_design_system__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
                    px: [
                        0,
                        3
                    ],
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_StyledHeading__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                            text: _constants_content__WEBPACK_IMPORTED_MODULE_5__/* ["default"].homepage.flights.expressDeals.headline */ .ZP.homepage.flights.expressDeals.headline,
                            fontSize: [
                                3,
                                null,
                                null,
                                5
                            ],
                            lineHeight: "display",
                            tag: "h1"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_StyledHeading__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                            text: _constants_content__WEBPACK_IMPORTED_MODULE_5__/* ["default"].homepage.flights.expressDeals.subHeadline */ .ZP.homepage.flights.expressDeals.subHeadline,
                            fontSize: [
                                1,
                                null,
                                null,
                                4
                            ],
                            mb: 3,
                            lineHeight: "display",
                            tag: "h2"
                        })
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(pcln_design_system__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
                    pb: 4,
                    px: [
                        0,
                        3
                    ],
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_SearchForm_Form__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                        onSubmit: function(values) {
                            return (0,_SearchForm_utils__WEBPACK_IMPORTED_MODULE_7__/* .onSubmitExpressDeal */ .pZ)((0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)({}, values), {
                                gaCategory: gaCategory
                            }));
                        },
                        promoDeal: true,
                        flightTypes: [
                            _constants__WEBPACK_IMPORTED_MODULE_6__/* .FLIGHT_TYPE_INFO */ .Yt[_constants__WEBPACK_IMPORTED_MODULE_6__/* .ROUND_TRIP */ .iF],
                            _constants__WEBPACK_IMPORTED_MODULE_6__/* .FLIGHT_TYPE_INFO */ .Yt[_constants__WEBPACK_IMPORTED_MODULE_6__/* .ONE_WAY */ .KW]
                        ]
                    })
                })
            ]
        })
    });
}


/***/ }),

/***/ 20977:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ IncredibleTileMediaCard; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/hooks/useContentfulVariation.ts + 1 modules
var useContentfulVariation = __webpack_require__(49356);
// EXTERNAL MODULE: ./src/components/Promos/MediaCard/MediaCardComponent.tsx + 1 modules
var MediaCardComponent = __webpack_require__(69582);
;// CONCATENATED MODULE: ./src/components/Promos/IncredibleTile/contentMediaCard.ts
var CONTENT = {
    contentTypeId: "mediaCard",
    internalName: "Media Card",
    overline: "",
    heading: "10% off coupon",
    subheading: "Book anything today and get 10% off your next Express Deal\xae Hotel",
    media: {
        title: "Incredible Tile Promo",
        description: "",
        file: {
            url: "https://s1.pclncdn.com/design-assets/home/promos/IncredibleTile.jpg",
            details: {
                size: 925398,
                image: {
                    width: 1200,
                    height: 400
                }
            },
            fileName: "IncredibleTile.jpg",
            contentType: "image/jpeg"
        }
    },
    primaryCallToAction: undefined
};
/* harmony default export */ var contentMediaCard = (CONTENT);

;// CONCATENATED MODULE: ./src/components/Promos/IncredibleTile/IncredibleTileMediaCard.tsx





function IncredibleTileMediaCard(param) {
    var contentFulFieldID = param.contentFulFieldID;
    var promo = (0,useContentfulVariation/* default */.Z)(contentFulFieldID);
    var hasContentfulData = promo != null;
    var mediaCardContent = hasContentfulData ? promo : contentMediaCard;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(MediaCardComponent/* default */.Z, {
        content: mediaCardContent
    });
}


/***/ }),

/***/ 69582:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ MediaCardComponent; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/pcln-design-system/lib-esm/Card/Card.js
var Card = __webpack_require__(70609);
// EXTERNAL MODULE: ./node_modules/@pcln/marketing/dist/esm/MediaCard/MediaCard.js + 1 modules
var MediaCard = __webpack_require__(51100);
// EXTERNAL MODULE: ./src/utils/analytics.ts
var analytics = __webpack_require__(94738);
// EXTERNAL MODULE: ./node_modules/@pcln/marketing/dist/esm/MoreInfo/MoreInfo.js
var MoreInfo = __webpack_require__(62818);
// EXTERNAL MODULE: ./node_modules/@pcln/contentful-components/lib-esm/ContentfulRichText/ContentfulRichText.js + 6 modules
var ContentfulRichText = __webpack_require__(77626);
;// CONCATENATED MODULE: ./src/components/Promos/Modal/MoreInfoModal.tsx





var MoreInfoModal = function(param) {
    var heading = param.heading, paragraph = param.paragraph, body = param.body, disclaimer = param.disclaimer, primaryCallToAction = param.primaryCallToAction, secondaryCallToAction = param.secondaryCallToAction, isOpen = param.isOpen, handleClose = param.handleClose, isFullHeight = param.isFullHeight;
    var bodyContent = function() {
        if (body) {
            return body;
        }
        if (paragraph) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(ContentfulRichText/* default */.Z, {
                body: paragraph
            });
        }
        return null;
    };
    var modalProps = {
        heading: heading,
        isFullHeight: isFullHeight,
        body: bodyContent(),
        disclaimer: disclaimer ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ContentfulRichText/* default */.Z, {
            body: disclaimer
        }) : null,
        primaryCallToAction: primaryCallToAction,
        secondaryCallToAction: secondaryCallToAction,
        isOpen: isOpen,
        onClose: handleClose,
        withModal: true,
        enableOverflow: true,
        disableCloseButton: true
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(MoreInfo/* default */.Z, (0,_object_spread/* default */.Z)({}, modalProps));
};
/* harmony default export */ var Modal_MoreInfoModal = (MoreInfoModal);

;// CONCATENATED MODULE: ./src/components/Promos/MediaCard/MediaCardComponent.tsx








function MediaCardComponent(param) {
    var content = param.content;
    var ref;
    var heading = content.heading, overline = content.overline, subheading = content.subheading, media = content.media, analyticsTracking = content.analyticsTracking, primaryCallToAction = content.primaryCallToAction;
    var ref1 = (0,react.useState)(false), isOpen = ref1[0], setIsOpen = ref1[1];
    var ref2 = (0,react.useState)(), currentModalProps = ref2[0], setCurrentModalProps = ref2[1];
    var handleOpen = function(modalProps, gaTracking) {
        if ((gaTracking === null || gaTracking === void 0 ? void 0 : gaTracking.category) && (gaTracking === null || gaTracking === void 0 ? void 0 : gaTracking.action) && (gaTracking === null || gaTracking === void 0 ? void 0 : gaTracking.label)) {
            var gaParams = {
                category: gaTracking === null || gaTracking === void 0 ? void 0 : gaTracking.category,
                action: gaTracking === null || gaTracking === void 0 ? void 0 : gaTracking.action,
                label: gaTracking === null || gaTracking === void 0 ? void 0 : gaTracking.label
            };
            analytics/* default.fireEvent */.Z.fireEvent(gaParams);
        }
        if (modalProps) {
            setCurrentModalProps(modalProps);
            setIsOpen(true);
        }
    };
    var handleClose = function() {
        setCurrentModalProps(undefined);
        setIsOpen(false);
    };
    (0,react.useEffect)(function() {
        if ((analyticsTracking === null || analyticsTracking === void 0 ? void 0 : analyticsTracking.action) && (analyticsTracking === null || analyticsTracking === void 0 ? void 0 : analyticsTracking.label)) {
            analytics/* default.fireEvent */.Z.fireEvent({
                category: analyticsTracking === null || analyticsTracking === void 0 ? void 0 : analyticsTracking.category,
                action: analyticsTracking === null || analyticsTracking === void 0 ? void 0 : analyticsTracking.action,
                label: analyticsTracking === null || analyticsTracking === void 0 ? void 0 : analyticsTracking.label
            });
        }
    }, [
        analyticsTracking
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal_MoreInfoModal, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, currentModalProps), {
                isFullHeight: false,
                isOpen: isOpen,
                handleClose: function() {
                    handleClose();
                }
            })),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Card/* default */.Z, {
                borderWidth: 0,
                width: [
                    1,
                    null,
                    1 / 2
                ],
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MediaCard/* default */.Z, {
                    handleOpen: handleOpen,
                    asset: {
                        file: {
                            contentType: "Image",
                            details: {
                                image: {
                                    height: 200,
                                    width: 600
                                }
                            },
                            fileName: media === null || media === void 0 ? void 0 : (ref = media.file) === null || ref === void 0 ? void 0 : ref.fileName,
                            url: media === null || media === void 0 ? void 0 : media.file.url
                        },
                        title: media === null || media === void 0 ? void 0 : media.title
                    },
                    callToAction: primaryCallToAction,
                    heading: heading,
                    overline: overline,
                    subheading: subheading,
                    objectFit: "cover",
                    objectPosition: "top"
                })
            })
        ]
    });
}


/***/ }),

/***/ 51197:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "IQ": function() { return /* binding */ CarsBumper; },
  "d7": function() { return /* binding */ CruiseBumper; },
  "HG": function() { return /* binding */ FlightsBumper; },
  "np": function() { return /* binding */ HotelsBumper; },
  "UB": function() { return /* binding */ VacationBumper; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/pcln-design-system/lib-esm/Box/Box.js
var Box = __webpack_require__(92591);
// EXTERNAL MODULE: ./node_modules/pcln-design-system/lib-esm/utils/utils.js
var utils = __webpack_require__(67113);
// EXTERNAL MODULE: ./node_modules/pcln-design-system/lib-esm/Button/Button.js
var Button = __webpack_require__(8316);
// EXTERNAL MODULE: ./node_modules/pcln-design-system/lib-esm/Text/Text.js + 2 modules
var Text = __webpack_require__(23720);
// EXTERNAL MODULE: ./node_modules/pcln-design-system/lib-esm/Link/Link.js
var Link = __webpack_require__(40869);
// EXTERNAL MODULE: ./node_modules/pcln-design-system/lib-esm/Flex/Flex.js
var Flex = __webpack_require__(92833);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(87379);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/pcln-design-system/lib-esm/BackgroundImage/BackgroundImage.js
var BackgroundImage = __webpack_require__(77072);
;// CONCATENATED MODULE: ./src/components/RotatingBanner.tsx



function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  0% { opacity: 0; }\n  50% { opacity: 1; }\n  51% { opacity: 0; }\n  100% { opacity: 0; }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  height: 100%;\n  position: relative;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  animation: ",
        " 8s infinite;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  animation: ",
        " 8s 4s infinite;\n  bottom: 0;\n  left: 0;\n  opacity: 0;\n  position: absolute;\n  right: 0;\n  top: 0;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background-color: transparent;\n  background-size: contain;\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}




var rotateText = (0,styled_components_browser_esm/* keyframes */.F4)(_templateObject());
var FlexWrapper = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).withConfig({
    componentId: "sc-5a895b37-0"
})(_templateObject1());
var PrimaryBanner = (0,styled_components_browser_esm/* default */.ZP)(Text/* default */.ZP).withConfig({
    componentId: "sc-5a895b37-1"
})(_templateObject2(), rotateText);
var SecondaryBanner = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).withConfig({
    componentId: "sc-5a895b37-2"
})(_templateObject3(), rotateText);
var StyledBackgroundImage = (0,styled_components_browser_esm/* default */.ZP)(BackgroundImage/* default */.Z).withConfig({
    componentId: "sc-5a895b37-3"
})(_templateObject4());
function RotatingBanner(_param) {
    var image = _param.image, primaryBannerText = _param.primaryBannerText, secondaryBannerText = _param.secondaryBannerText, props = (0,_object_without_properties/* default */.Z)(_param, [
        "image",
        "primaryBannerText",
        "secondaryBannerText"
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(FlexWrapper, {
        alignItems: "center",
        flexDirection: "column",
        justifyContent: "center",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(PrimaryBanner, {
                color: "primary",
                fontWeight: "normal",
                children: [
                    primaryBannerText,
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("sup", {
                        children: "*"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(SecondaryBanner, {
                alignItems: "center",
                justifyContent: "center",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.ZP, {
                        color: "primary",
                        fontWeight: "normal",
                        children: secondaryBannerText
                    }),
                    image && /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                        mx: 3,
                        width: "310px",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledBackgroundImage, (0,_object_spread/* default */.Z)({
                            image: "".concat(image, "?opto&auto=webp")
                        }, props))
                    })
                ]
            })
        ]
    });
}

// EXTERNAL MODULE: ./src/hooks/useExpressDealModal.ts
var useExpressDealModal = __webpack_require__(77185);
// EXTERNAL MODULE: ./src/components/Flights/ExpressDeal/ExpressDealModal.tsx
var ExpressDealModal = __webpack_require__(84469);
// EXTERNAL MODULE: ./src/constants/analytics.ts
var analytics = __webpack_require__(66487);
// EXTERNAL MODULE: ./src/context/SearchFormContext.tsx
var SearchFormContext = __webpack_require__(51069);
// EXTERNAL MODULE: ./src/components/Hotels/SearchForm/utils.ts
var SearchForm_utils = __webpack_require__(84822);
// EXTERNAL MODULE: ./src/components/ConditionalRender/index.tsx + 2 modules
var ConditionalRender = __webpack_require__(93314);
;// CONCATENATED MODULE: ./src/components/SearchForm/Bumpers.tsx
/* eslint-disable react/jsx-pascal-case */ 
function Bumpers_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  border-top: 1px solid ",
        ";\n"
    ]);
    Bumpers_templateObject = function _templateObject() {
        return data;
    };
    return data;
}











var imageFolder = "https://s1.pclncdn.com/design-assets/next-landing/assets/images/bumper/";
var Wrapper = (0,styled_components_browser_esm/* default */.ZP)(Box/* default */.Z).attrs(function() {
    return {
        p: 3
    };
}).withConfig({
    componentId: "sc-7b7a18ef-0"
})(Bumpers_templateObject(), (0,utils/* getPaletteColor */.ow)("border.base"));
function FlightsBumper() {
    var ref = (0,useExpressDealModal/* default */.Z)(), isOpen = ref.isOpen, openModal = ref.openModal;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Wrapper, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Button/* default */.ZP, {
            color: "transparent",
            onClick: openModal,
            p: 0,
            width: 1,
            "aria-label": "Save up to 50% by searching Express Deals.",
            "data-testid": "flight-express-deal-bumper",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(ExpressDealModal/* default */.Z, {
                    isModalOpen: isOpen,
                    gaCategory: analytics/* ANALYTICS_CATEGORY_HOME */.DG
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(RotatingBanner, {
                    height: "25px",
                    image: "".concat(imageFolder, "flights_logo_bumper.jpg?opto&auto=webp"),
                    primaryBannerText: "Save up to 50% by searching Express Deals.",
                    secondaryBannerText: "Trusted airlines, incredible deals."
                })
            ]
        })
    });
}
function CarsBumper() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Wrapper, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(RotatingBanner, {
            height: "25px",
            image: "".concat(imageFolder, "rcBumper.png?opto&auto=webp"),
            primaryBannerText: "Save up to 40% by searching Express Deals.",
            secondaryBannerText: "Trusted brands, incredible deals."
        })
    });
}
function VacationBumper() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Wrapper, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.ZP, {
            fontSize: 1,
            textAlign: "center",
            color: "text.light",
            children: "Save up to $625 when you book your hotel and flight together!"
        })
    });
}
function CruiseBumper() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Wrapper, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* default */.ZP, {
            fontSize: 1,
            textAlign: "center",
            color: "text.light",
            children: [
                "Get up to $1,000 to spend at sea when you\xa0",
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default.span */.ZP.span, {
                    fontWeight: "bold",
                    color: "primary",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                        href: "https://cruises.priceline.com?utm_medium=partner_site_banner&utm_source=pcln-partner_site&utm_campaign=20190307&utm_content=widget_link",
                        target: "_blank",
                        children: "book a cruise with Priceline."
                    })
                })
            ]
        })
    });
}
function HotelsBumper(param) {
    var showMultiHotel = param.showMultiHotel;
    var formValues = (0,react.useContext)(SearchFormContext/* SearchFormContext */.j).formValues;
    // do not show bumper when testing multi hotel radio buttons
    if (showMultiHotel) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Wrapper, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.ZP, {
            fontSize: 1,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
                flexWrap: "wrap",
                justifyContent: "center",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(ConditionalRender/* default */.ZP, {
                    experimentCode: "PKG_FE_MULTI_HOTEL_HYPERLINK",
                    variantValue: "VARIANT",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(ConditionalRender/* Original */.gg, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default.span */.ZP.span, {
                                    color: "text.light",
                                    children: "On a multi-destination trip?\xa0"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default.span */.ZP.span, {
                                    fontWeight: "bold",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                                        href: (0,SearchForm_utils/* formatShopSearchLink */.Uo)(formValues),
                                        target: "_blank",
                                        children: "Book up to five hotel stays"
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ConditionalRender/* Experiment */.KS, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                                href: (0,SearchForm_utils/* formatShopSearchLink */.Uo)(formValues),
                                target: "_blank",
                                children: "Book all of your hotels at once and save up to $625"
                            })
                        })
                    ]
                })
            })
        })
    });
}


/***/ }),

/***/ 67685:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "RN": function() { return /* binding */ AMENITIES; },
/* harmony export */   "bW": function() { return /* binding */ PRODUCT_TABS; },
/* harmony export */   "ob": function() { return /* binding */ HEADERS; }
/* harmony export */ });
var PRODUCT_TABS = [
    {
        autobotID: "DASH_TAB_HOTELS",
        name: "HOTELS",
        tabText: "Hotels",
        id: "hotels",
        query: {
            tab: "hotels"
        }
    },
    {
        autobotID: "DASH_TAB_FLIGHTS",
        name: "FLIGHTS",
        tabText: "Flights",
        id: "flights",
        query: {
            tab: "flights"
        }
    },
    {
        autobotID: "DASH_TAB_HOTEL + FLIGHT",
        name: "BUNDLE + SAVE",
        tabText: "Bundle & Save",
        id: "vacations",
        query: {
            tab: "vacations"
        }
    },
    {
        autobotID: "DASH_TAB_CARS",
        name: "CARS",
        tabText: "Cars",
        id: "cars",
        query: {
            tab: "cars"
        }
    },
    {
        autobotID: "DASH_TAB_CRUISES",
        name: "CRUISES",
        tabText: "Cruises",
        id: "cruises",
        query: {
            tab: "cruises"
        }
    }
];
var HEADERS = {
    hotels: {
        headline: "Save more on your next hotel",
        subheadline: "Thousands of deals made every day",
        mobileHeadline: "Save more on your next hotel"
    },
    flights: {
        headline: "Save more on your next flight",
        subheadline: "Thousands of deals made every day",
        mobileHeadline: "Save more on your next flight"
    },
    vacations: {
        headline: "Save up to $625 on your hotel and flight",
        subheadline: "Book together for our best deals",
        mobileHeadline: "Save up to $625 on your hotel and flight"
    },
    cars: {
        headline: "Save more on your next rental car",
        subheadline: "Thousands of deals made every day",
        mobileHeadline: "Save more on your next rental car"
    },
    cruises: {
        headline: "Save more on your next cruise",
        subheadline: "Thousands of deals made every day",
        mobileHeadline: "Save more on your next cruise"
    }
};
var AMENITIES = {
    AIRSHUTTL: "Search Hotels with Airport Shuttles",
    CASINO: "Search Hotels with Casinos",
    FBRKFST: "Search Hotels with Free Breakfast",
    FINTRNT: "Search Hotels with Free Internet",
    FITSPA: "Search Hotels with Gyms",
    FPRKING: "Search Hotels with Free Parking",
    INCLUSIVE: "Search All Inclusive Hotels",
    KITCHEN: "Search Hotels with Kitchens",
    PETALLOW: "Search Pet Friendly Hotels",
    SPOOL: "Search Hotels with Swimming Pools",
    RESTRNT: "Search Hotels with Restaurants",
    SPA: "Search Hotels with Spas"
};


/***/ }),

/***/ 66410:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "gL": function() { return /* binding */ GREETING_DESKTOP; }
/* harmony export */ });
/* unused harmony export GREETING_MOBILE */
var GREETING_MOBILE = "Welcome to Priceline";
var GREETING_DESKTOP = "Welcome to Priceline";
var Content = {
    homepage: {
        hotel: {
            signedInSubHeading: "You qualify for VIP hotel deals! Search and save.",
            expressDeals: {
                headline: "Search for Express Deals",
                subHeadline: "Save up to 60% Fast and Easy - No Bidding Required!"
            }
        },
        flights: {
            expressDeals: {
                headline: "Search for Express Deals",
                subHeadline: "Save up to 50% on trusted airlines!"
            }
        },
        vip: {
            defaultHeading: GREETING_MOBILE,
            headlineWithName: "{firstName}, you qualify for VIP deals",
            promo: {
                headline: "You qualify for hotel discounts of up to 50% as a VIP member!",
                headlineWithName: "{firstName}, you qualify for hotel discounts of up to 50% as a VIP member!",
                subHeadline: "Book Priceline VIP deals for your exclusive savings"
            }
        }
    }
};
/* harmony default export */ __webpack_exports__["ZP"] = (Content);


/***/ }),

/***/ 40813:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ useCityNameInFormHeadlineForSEM; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _context_BootstrapDataContext__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(68464);


function useCityNameInFormHeadlineForSEM(location) {
    var ref;
    var prePopData = (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(_context_BootstrapDataContext__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z).prePopData;
    var endLocation = prePopData === null || prePopData === void 0 ? void 0 : (ref = prePopData.hotels) === null || ref === void 0 ? void 0 : ref.endLocation;
    var hasCity = !!(endLocation === null || endLocation === void 0 ? void 0 : endLocation.cityName) && (endLocation === null || endLocation === void 0 ? void 0 : endLocation.type) === "CITY";
    return hasCity ? "Search ".concat((location === null || location === void 0 ? void 0 : location.cityName) || (endLocation === null || endLocation === void 0 ? void 0 : endLocation.cityName), " Hotels") : null;
}


/***/ }),

/***/ 77185:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ useExpressDealModal; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(14924);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(69396);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var ramda__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67763);





function useExpressDealModal() {
    var qsKey = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "modal", qsValue = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "express-deals";
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_0__.useRouter)();
    var query = router.query, pathname = router.pathname;
    var isOpen = query[qsKey] === qsValue;
    var openModal = function() {
        router.push({
            pathname: pathname,
            query: (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, query), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, qsKey, qsValue))
        }, undefined, {
            shallow: true
        });
    };
    var closeModal = function() {
        router.push({
            pathname: pathname,
            query: (0,ramda__WEBPACK_IMPORTED_MODULE_1__/* .omit */ .CEd)([
                qsKey
            ], query)
        }, undefined, {
            shallow: true
        });
    };
    return {
        isOpen: isOpen,
        openModal: openModal,
        closeModal: closeModal
    };
}


/***/ }),

/***/ 32881:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ useSEMSearchHeadline; }
/* harmony export */ });
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _components_SearchForm_constants__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67685);


function useSEMSearchHeadline() {
    var ref;
    var query = (0,next_router__WEBPACK_IMPORTED_MODULE_0__.useRouter)().query;
    var SEMSearch = query.SEMSearch, SEMSEARCH = query.SEMSEARCH;
    var semSearchParam = (ref = SEMSearch || SEMSEARCH) === null || ref === void 0 ? void 0 : ref.toUpperCase();
    return _components_SearchForm_constants__WEBPACK_IMPORTED_MODULE_1__/* .AMENITIES */ .RN[semSearchParam];
}


/***/ })

}]);